module.exports = __webpack_public_path__ + "static/img/xiaoyuzhou.190ea58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/nxyp1/xiaoyuzhou.jpg
// module id = 4tFe
// module chunks = 0